// extracted by mini-css-extract-plugin
module.exports = {"infoIcon":"ActiveUserInDaysChart_infoIcon__14Fd1","info":"ActiveUserInDaysChart_info__eZzUZ","infoValue":"ActiveUserInDaysChart_infoValue__jwD2I"};